<template>
  <div class="advform ops-form-ft ops-tags-input">

    <!-- From element -->

    <div class="uk-grid-small" uk-grid>
      <!-- Header -->
      <div class="uk-container-expand">
        <span class="uk-label">{{inputelement.chLibs}}</span>

<!--        <div v-if="selected==='FT' || selected==='FTE'" uk-form-custom="target: > * > span:first-child">
          <select v-model="selected" @change="changeType">
            <option value="FT">contient</option>
            <option value="FTE">contient stricte</option>
          </select>
          <button class="uk-button uk-button-default" type="button" tabindex="-1">
            <span></span>
            <span class="uk-margin-small-left" uk-icon="icon: chevron-down ; ratio: 0.5"></span>
          </button>
        </div>-->
      </div>
      <!-- END Header -->

      <template v-if="haveAutocompletion">
        <div class="uk-inline uk-width-expand@m">
            <vue-tags-input
              ref="tagsInput"
              v-model="tag"
              :tags="tags"
              :autocomplete-items="autocompleteItems"
              :add-only-from-autocomplete="isOnlyFromAutocompletion"
              :autocomplete-min-length="autocompletionOnFocus"
              :placeholder=inputelement.placeholder
              autocomplete="new-password"
              :allow-edit-tags="true"
              @tags-changed="handleTagsChanged"
              @before-adding-tag="addAndOr"
              @before-deleting-tag="removeAndOr"
            >
            <template slot="tag-left" slot-scope="props">
              <span v-on:click="changeAndOr(props.index)" class="ops-select">{{ displayAndOr(props.index) }}</span>
            </template>
          </vue-tags-input>
        </div>
      </template>
      <template v-else>
        <div class="uk-inline uk-width-expand@m">
          <vue-tags-input
            ref="tagsInput"
            v-model="tag"
            :tags="tags"
            :placeholder=inputelement.placeholder
            autocomplete="new-password"
            :allow-edit-tags="true"
            @tags-changed="handleTagsChanged"
            @before-adding-tag="addAndOr"
            @before-deleting-tag="removeAndOr"
            @keyup.enter="handleEnter"
          >
          <template slot="tag-left" slot-scope="props">
              <span v-on:click="changeAndOr(props.index)" class="ops-select">{{ displayAndOr(props.index) }}</span>
          </template>
          </vue-tags-input>
        </div>
      </template>

        <div class="uk-form-custom"
             v-if="inputelement.chFields.toUpperCase() === 'ITOUSTI' ||
             inputelement.chFields.toUpperCase() === 'ITOUSTI,[E]ITOUSTI_EXACT^4' ||
             inputelement.chFields.toUpperCase() === 'ITOUSTI_EXACT'"
        >
          <input type="checkbox" class="uk-checkbox uk-margin-small-right" v-model="isExactChecked" @change="toggleExact" />locution exacte
        </div>

        <div class="uk-form-custom"
              v-if="inputelement.chFields.toUpperCase() === 'ITOUSTEXT' ||
              inputelement.chFields.toUpperCase() === 'IMOTSCLES'"
        >
          <input type="checkbox" class="uk-checkbox uk-margin-small-right" v-model="isThesaurusChecked" @change="toggleThesaurus" />avec thésaurus
        </div>

      <template v-if="haveIndexIframe">
        <!-- OPEN MODAL BTN -->
<!--          <div class="inputoption uk-width-auto@m">
            <i
              class="deleteFormCritere"
              @click="log(inputelement)"
              uk-icon="icon: m_collections_bookmark; ratio: 1"></i>
          </div>-->

          <!-- MODAL IFRAME-->
<!--          <div uk-dropdown="mode: click; pos: top-left">
            <iframe :src="iframesrc" @load="iframeLoaded" width="500" height="450" frameborder="0"></iframe>
          </div>-->

        <!-- OPEN OFF-CANVAS BTN -->
        <div class="inputoption uk-width-auto@m">
          <i
            class="deleteFormCritere"
            @click="openOffCanvas(inputelement.id)"
            uk-icon="icon: m_collections_bookmark; ratio: 1"></i>
        </div>

        <!-- OFF-CANVAS IFRAME-->
        <div :id="'offcanvas-iframe-' + inputelement.id" uk-offcanvas="flip: true;overlay: true">
          <div class="uk-offcanvas-bar">
            <button class="uk-offcanvas-close" type="button" uk-close></button>
            <iframe :src="iframesrc" @load="iframeLoaded" class="iframe-full" frameborder="0"></iframe>
          </div>
        </div>

      </template>

      <!-- DELETE BTN -->
      <div class="menu uk-width-auto@m">
        <i
          class="deleteFormCritere"
          @click="deleteFormCritere(inputelement)"
          uk-icon="icon: minus-circle; ratio: 1.5"></i>
      </div>

    </div>
    <!-- END From element -->

  </div>
</template>

<script>
import { VueTagsInput, createTags } from '@johmun/vue-tags-input'
import { mapActions, mapGetters, mapState } from 'vuex'
import axios from 'axios'
import { EventBus } from '../../main'

export default {
  name: 'InputAutoText',
  props: ['inputelement'],
  components: {
    VueTagsInput
  },
  data () {
    return {
      baseApiUrl: process.env.VUE_APP_TAG_API,
      envVar: process.env.VUE_APP_ENV,
      tag: '',
      tags: [],
      autocompleteItems: [],
      debounce: null,
      tagsOperator: [],
      tagJson: [],
      tempTagUrl: '',
      selected: this.inputelement.hasOwnProperty('chTypes') ? this.inputelement.chTypes : 'no',
      isExactChecked: this.inputelement.chFields === 'ITOUSTI_EXACT',
      isThesaurusChecked: this.inputelement.chValues2,
      iframesrc: '',
      haveAutocompletion: this.inputelement.hasOwnProperty('autocomplete'),
      isOnlyFromAutocompletion: this.inputelement.hasOwnProperty('onlyAutocomplete') ? this.inputelement.onlyAutocomplete : false,
      autocompletionOnFocus: this.inputelement.hasOwnProperty('autocompletionOnFocus') ? 0 : 1,
      haveIndexIframe: this.inputelement.hasOwnProperty('index') ? this.inputelement.index : false,
      haveDataStorage: this.inputelement.hasOwnProperty('chValues') ? this.inputelement.chValues : '',
      hasJustAddedTag: false, // Nouvel état pour gérer l'ajout de tags
      bypassAutocompleteFilter: false,
      previousTags: [] // Pour comparer les modifications
    }
  },
  mounted () {
    const inputElement = this.$refs.tagsInput.$el.querySelector('input')
    if (inputElement) {
      inputElement.addEventListener('keyup', this.handleEnterKey)
      inputElement.addEventListener('click', this.openAutocomplete) // Ajouter cette ligne
    }
    if (this.haveDataStorage !== '') {
      if (Array.isArray(this.haveDataStorage)) {
        // console.log('#AKIDEBUG : haveDataStorage OK')
        this.haveDataStorage.forEach((value, index) => {
          // console.log('#AKIDEBUG : Insert = > Operator:', value.operator, ' / TAG: ', value.tag)
          // Operator
          this.tagsOperator.push(value.operator)
          this.tagJson.push({ operator: value.operator, tag: value.tag })
          // Value
          this.tags = [...this.tags, ...createTags([value.tag], ['ti-valid'])]
        })
      } else {
        /* Todo if load value ? */
        // console.log('#AKIDEBUG : haveDataStorage is not a array')
      }
    } else {
      // console.log('#AKIDEBUG : EMPTY haveDataStorage on TextInput Mounted()')
    }
  },
  beforeDestroy () {
    const inputElement = this.$refs.tagsInput.$el.querySelector('input')
    if (inputElement) {
      inputElement.removeEventListener('keyup', this.handleEnterKey)
      inputElement.removeEventListener('click', this.openAutocomplete)
    }
  },
  computed: {
    ...mapState(['resetForm']),
    filteredItems () {
      if (!this.tag || this.tag === '') {
        return this.autocompleteItems // Return All items if no tag
      }
      return this.autocompleteItems.filter(i => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
    ...mapGetters(['getBaseUrl'])
  },
  watch: {
    tag () {
      this.updateAutocomplete()
    },
    tags () {
      this.clearAutocompleteOnNewTag()
    },
    resetForm (newValue) {
      if (newValue) {
        this.resetData()
      }
    }
  },
  methods: {
    ...mapActions([
      'emitSaveFieldValue',
      'emitCleanRequeteNode',
      'emitClearFormEnded'
    ]),
    resetData () {
      // Init Input
      // Clear From Store emitClearForm in Parent component
      this.tags = []
      this.autocompleteItems = []
      this.tagJson = []
      this.tagsOperator = []
      this.tag = ''
      this.debounce = null

      setTimeout(() => {
        this.emitClearFormEnded()
      }, 300) // set resetForm store var to FALSE
    },
    log: function (evt) {
      // Open Modal
      window.console.log(evt)
    },
    openOffCanvas (id) {
      UIkit.offcanvas('#offcanvas-iframe-' + id).show()
    },
    deleteFormCritere (element) {
      this.$emit('deleteCritere', element)
    },
    addAndOr (obj) {
      const value = obj.tag.text.trim()
      // Tag déjà présent, ne rien ajouter
      if (this.tags.some(t => t.text === value)) {
        return
      }

      this.hasJustAddedTag = false // Réinitialiser l'état pour handleEnterKey

      var operator = this.tagsOperator.length ? 'ou' : ''
      this.tagsOperator.push(operator)
      this.tagJson.push({ operator: operator, tag: value })
      obj.addTag()

      // Clean the quotes from each element in this.tagJson
      this.tagJson = this.tagJson.map(item => ({
        ...item,
        tag: item.tag.replace(/"/g, '')
      }))
      // SAVE
      this.$set(this.inputelement, 'chValues', this.tagJson)
      // EXPORT SEND
      this.emitCleanRequeteNode(this.inputelement)
    },
    removeAndOr (obj) {
      this.tagsOperator.splice(obj.index, 1)
      this.$set(this.tagsOperator, 0, '')
      this.tagJson.splice(obj.index, 1)
      obj.deleteTag()
      // SAVE
      this.$set(this.inputelement, 'chValues', this.tagJson)
      // EXPORT SEND
      this.emitCleanRequeteNode(this.inputelement)
    },
    changeAndOr: function (index) {
      const operators = ['ou', 'et', 'sf']
      const currentIndex = operators.indexOf(this.tagsOperator[index])
      const nextIndex = (currentIndex + 1) % operators.length
      const operator = operators[nextIndex]

      // var operator = (this.tagsOperator[index] === "et") ? 'ou' : 'et';
      this.$set(this.tagsOperator, index, operator) // update operator
      this.tagJson[index].operator = operator // update Json
    },
    displayAndOr: function (index) {
      return this.tagsOperator[index]
    },
    update (newTags) {
      console.log('update', newTags)
      this.autocompleteItems = []
      this.tags = newTags
    },
    handleTagsChanged (newTags) {
      // Même nombre de tags, donc potentiellement une modification || pas de previousTags si chargeé par import
      if (this.previousTags.length === 0 || (newTags.length === this.previousTags.length)) {
        newTags.forEach((tag, index) => {
          // Vérifie si le texte du tag a été modifié || pas de previousTags si chargeé par import
          if (this.previousTags.length === 0 || (this.previousTags[index] && tag.text !== this.previousTags[index].text)) {
            // Mettre à jour le tagJson et Émettre les mises à jour
            if (index < this.tagJson.length) {
              this.$set(this.tagJson, index, {
                ...this.tagJson[index],
                tag: tag.text
              })
              this.$set(this.inputelement, 'chValues', this.tagJson)
              this.emitCleanRequeteNode(this.inputelement)
            }
          }
        })
      }

      // Mettre à jour l'état des tags
      this.tags = newTags
      // Sauvegarder l'état pour la prochaine comparaison
      this.previousTags = JSON.parse(JSON.stringify(newTags))
    },
    handleEnterKey (event) {
      if (event.key === 'Enter') {
        if (this.hasJustAddedTag) {
          // Si l'utilisateur appuie sur Entrée une deuxième fois avec un champ vide
          if (this.tag === '') {
            // console.log('SEND');
            SKOPUS.ACTIONS.createSpinnerOverlay()
            this.$root.$emit('submit-form')
          }
        } else {
          // Lors de la première entrée, on attend que le tag soit ajouté
          // console.log('DONT SEND');
          this.hasJustAddedTag = true
        }
      }
    },
    clearAutocompleteOnNewTag () {
      this.bypassAutocompleteFilter = false
      clearTimeout(this.debounce)
      this.autocompleteItems = []
    },
    openAutocomplete () {
      this.bypassAutocompleteFilter = true
      this.updateAutocomplete()
    },
    updateAutocomplete () {
      // EVERY KEYPRESS IN FORM INPUT
      this.emitCleanRequeteNode()
      if (this.tag.length < this.autocompletionOnFocus) return // Prevent shadow load if = 1
      if (this.tags.length > 0 && this.tag.length > 0) {
        // Désactive le filtrage de l'autocomplétion lors d'un retour arrière
        // Permet d'afficher toutes les suggestions (sans filtrage de la première lettre)
        this.bypassAutocompleteFilter = true
      }
      // Affiche l'autocomplétion dans l'un des cas suivants :
      // - aucun tag existant
      // - au moins un caractère saisi
      // - mode bypass activé (après effacement d'un caractère)
      if (this.tag.length > 0 || this.bypassAutocompleteFilter) {
        const query = this.tag ? encodeURIComponent(this.tag) : ''
        if (this.envVar === 'dev') {
          this.tempTagUrl = `https://itunes.apple.com/search?term=${query}&entity=allArtist&attribute=allArtistTerm&limit=6&output=json`
        } else {
          this.tempTagUrl = this.getBaseUrl + `empty.php?urlaction=chercheMotsSolr&output=json&type=${this.inputelement.autocomplete}&debut=${query}`
        }
        clearTimeout(this.debounce)
        this.debounce = setTimeout(() => {
          axios.get(this.tempTagUrl).then(response => {
            this.autocompleteItems = response.data.results.map(a => {
              if (this.envVar === 'dev') {
                return { text: a.artistName }
              } else {
                // Todo : ask label name
                return { text: a.option }
              }
            })
          }).catch((e) => console.warn('Oh. Something went wrong JSON !', e))
        }, 600)
      }
    },
    changeType () {
      this.$set(this.inputelement, 'chTypes', this.selected)
      this.emitSaveFieldValue(this.inputelement)
    },
    toggleExact () {
      if (this.isExactChecked) {
        this.$set(this.inputelement, 'chFields', 'ITOUSTI_EXACT')
        this.$set(this.inputelement, 'chTypes', 'FTE')
        this.$set(this.inputelement, 'autocomplete', 'ITOUSTI_EXACT')
      } else {
        this.$set(this.inputelement, 'chFields', 'itousti,[E]itousti_exact^4')
        this.$set(this.inputelement, 'chTypes', 'FT')
        this.$set(this.inputelement, 'autocomplete', 'itousti')
      }
      this.emitSaveFieldValue(this.inputelement)
    },
    toggleThesaurus () {
      if (this.isThesaurusChecked) {
        this.$set(this.inputelement, 'chValues2', 1)
      } else {
        this.$set(this.inputelement, 'chValues2', 0)
      }
      this.emitSaveFieldValue(this.inputelement)
    },
    iframeUrl () {
      if (this.envVar === 'dev') {
        if (this.inputelement.id === 100 || this.inputelement.id === 80 || this.inputelement.id === 60) {
          this.iframesrc = 'testpalette/palette' + this.inputelement.id + '.html'
        } else {
          this.iframesrc = 'testpalette/palette.html'
        }
      } else if (this.inputelement.hasOwnProperty('bypassPalette') && this.inputelement.bypassPalette !== '') {
        this.iframesrc = this.getBaseUrl + this.inputelement.bypassPalette + '&id_input_result=' + this.inputelement.id
      } else {
        /* todo : prise en compte de la valeur "index" */
        this.iframesrc = this.getBaseUrl + 'palette.php' +
                        '?urlaction=chercheIndexSolr' +
                        '&id_lang=FR' +
                        '&titre_index=' + this.inputelement.chLibs +
                        '&champ=' + this.inputelement.autocomplete +
                        '&id_champ=' + this.inputelement.id
        // + '&id_input_result=' + encodeURI(this.tag)
        // console.log('#AKIDEBUG : iframesrc = ', this.iframesrc)
      }
    },
    iframeLoaded () {
      this.iframeUrl()
      EventBus.$on('pallette-iframe', (payLoad) => {
        if (payLoad.id_champ === this.inputelement.id) {
          // console.log('#AKIDEBUG : iframeLoaded Receive in COMPONENTS TextInputAuto inputelement.id =' + this.inputelement.id)
          let isDupucateTags = this.tags.filter(tag => {
            return tag.text === payLoad.valeur
          })
          if (isDupucateTags.length === 0) {
            /* Todo Voir Last after delete TAG ( = doublon && happy && happy ) */
            // console.log('#AKIDEBUG : VALUES : ', this.inputelement.chValues)
            // Operator
            var operator = this.tagsOperator.length ? 'ou' : ''
            this.tagsOperator.push(operator)
            this.tagJson.push({ operator: operator, tag: payLoad.valeur })
            // Clean the quotes from each element in this.tagJson
            this.tagJson = this.tagJson.map(item => ({
              ...item,
              tag: String(item.tag).replace(/"/g, '')
            }))
            // SAVE
            this.$set(this.inputelement, 'chValues', this.tagJson)
            // Show tag in input
            this.tags = [...this.tags, ...createTags([payLoad.valeur], ['ti-valid'])]
            // EXPORT SEND
            this.emitSaveFieldValue(this.inputelement)
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    background-color: transparent !important;
    color: inherit !important;
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
  }

  .ops-tags-input .vue-tags-input {
    max-width: none;
  }

  .ops-tags-input .ti-input {
    padding: 2px 4px;
    min-height: 40px;
    border: 1px solid #E9E9E9;
    border-radius: 6px;
  }

  .ops-tags-input .ti-input .ti-tags {
    min-height: 40px;
  }

  .ops-tags-input .ti-tag.ti-tag.ti-invalid,
  .ops-tags-input .ti-tag.ti-tag.ti-deletion-mark,
  .ops-tags-input .ti-tag {
    margin-left: 35px;
    background-color: #0186B1;
    padding: 5px 10px;
  }

  .ops-tags-input .ti-content {
    position: relative;
  }

  .ops-tags-input .ti-tag span {
    font-size: 14px;
    line-height: 14px;
  }

  .ops-tags-input .ti-tag-left {
    position: absolute;
    left: -40px;
    background-color: #D8D8D8;
    color: #4A4A4A;
    border-radius: 100%;
    width: 24px;
    height: 24px;
    text-align: center;
    font-size: 12px;
    line-height: 24px;
    cursor: pointer;
  }

  .ops-tags-input .ti-tag-left:hover {
    background-color: #cccccc;
  }

  .ops-tags-input .ti-tag.ti-tag.ti-invalid:first-child,
  .ops-tags-input .ti-tag.ti-tag.ti-deletion-mark:first-child,
  .ops-tags-input .ti-tag:first-child {
    margin-left: 0;
  }

  .ops-tags-input .ti-tag:first-child .ti-tag-left {
    display: none;
  }

  .et {
    background-color: #D8D8D8;
  }

  .ou {
    background-color: red;
  }

  .form-list-wrap .uk-label {
    display: inline-block;
    padding: 1px 10px;
    border-radius: 25px;
    text-decoration: none;
    color: #2D3C53;
    font-weight: 600;
    background: #ffffff;
    transition: .4s;
    text-transform: none;
    font-size: 12px;
    margin: 5px 5px 7px 0;
    min-width: 100px;
  }

  .form-list-wrap .uk-button {
    display: inline-block;
    padding: 0 15px;
    border-radius: 25px;
    text-decoration: none;
    font-weight: 600;
    background: #E9E9E9;
    border: 1px solid #DFDFDF;
    color: #626D7E;
    height: 26px;
    line-height: 26px;
    transition: .4s;
    text-transform: none;
    font-size: 12px;
    line-height: 1;
  }

  .form-list-wrap .uk-button .ops-primary-color {
    color: #0186B1;
  }

  .ops-tags-input .menu {
    padding: 2px 0 0 15px;
    cursor: pointer;
  }

  .ops-tags-input .uk-form-icon {
    background-color: #075068;
    color: #ffffff;
  }

  .ops-tags-input .menu .uk-icon {
    color: #075068;
  }

  .ops-tags-input .menu .uk-icon:hover {
    color: red;
  }

  .ops-tags-input .inputoption {
    padding: 6px 10px; margin-left:15px;
    border-radius: 6px;
    border: 1px solid #B8DEE6;
    background: #CEEBF2;
    color:#3782AA;
    cursor: pointer;
    height:38px;
  }

  .deleteFormCritere {
    float: right;
  }

  .advform .uk-input {
    height: 40px;
    border: 1px solid #E9E9E9;
    border-radius: 6px;
    color: #222222;
    font-size: 12px;
  }

  .form-list-wrap .ti-selected-item {
    background-color: #0186B1;;
  }

  .form-list-wrap ul.list-group li.ti-new-tag-input-wrapper {
    /* contre ul li*/
    border: none;
    margin: 2px;
    padding: 3px 5px;
  }

  .ti-autocomplete {
    z-index: 2;
  }

  /* Modal iframe*/
  .advform .uk-grid-margin {
    margin-top: 0;
  }

  .uk-dropdown {
    padding: 0
  }

</style>
<style>
  ti-input .ti-tags {
    min-height: auto;
    height: 40px !important;
  }

  .uk-offcanvas-bar {
    padding: 0; /* Remove padding if needed */
    display: flex;
    flex-direction: column;
    height: 100%; /* Ensure the bar takes full height */
  }

  .iframe-full {
    flex: 1; /* Allow the iframe to take the remaining space */
    width: 100%;
    border: none;
  }

  /* import from TagInput.vue */
  .ops-tags-input .vue-tags-input {
    max-width: none;
  }

  .ops-tags-input .ti-input {
    padding: 2px 4px;
    min-height: 34px;
    border: 1px solid #E9E9E9;
    border-radius: 6px;
  }

  .ops-tags-input .ti-tag.ti-tag.ti-invalid,
  .ops-tags-input .ti-tag.ti-tag.ti-deletion-mark,
  .ops-tags-input .ti-tag {
    margin-left: 35px;
    background-color: #0186B1;
    padding: 5px 10px;
  }

  .ops-tags-input .ti-content {
    position: relative;
  }

  .ops-tags-input .ti-tag span {
    font-size: 14px;
    line-height: 14px;
  }

  .ops-tags-input .ti-tag-left {
    position: absolute;
    left: -40px;
    background-color: #D8D8D8;
    color: #4A4A4A;
    border-radius: 100%;
    width: 24px;
    height: 24px;
    text-align: center;
    font-size: 12px;
    line-height: 24px;
    cursor: pointer;
  }

  .ops-tags-input .ti-tag-left:hover {
    background-color: #cccccc;
  }

  .ops-tags-input .ti-tag.ti-tag.ti-invalid:first-child,
  .ops-tags-input .ti-tag.ti-tag.ti-deletion-mark:first-child,
  .ops-tags-input .ti-tag:first-child {
    margin-left: 0;
  }

  .ops-tags-input .ti-tag:first-child .ti-tag-left {
    display: none;
  }

  .et {
    background-color: #D8D8D8;
  }

  .ou {
    background-color: red;
  }

  .form-list-wrap .uk-label {
    display: inline-block;
    padding: 1px 10px;
    border-radius: 25px;
    text-decoration: none;
    color: #2D3C53;
    font-weight: 600;
    background: #ffffff;
    transition: .4s;
    text-transform: none;
    font-size: 12px;
  }

  .form-list-wrap .uk-button {
    display: inline-block;
    padding: 0 15px;
    border-radius: 25px;
    text-decoration: none;
    font-weight: 600;
    background: #E9E9E9;
    border: 1px solid #DFDFDF;
    color: #626D7E;
    height: 26px;
    line-height: 26px;
    transition: .4s;
    text-transform: none;
    font-size: 12px;
  }

  .form-list-wrap .uk-button .ops-primary-color {
    color: #0186B1;
  }

  .ops-tags-input .menu {
    padding: 2px 0 0 15px;
    cursor: pointer;
  }

  .ops-tags-input .uk-form-icon {
    background-color: #075068;
    color: #ffffff;
  }

  .ops-tags-input .menu .uk-icon {
    color: #075068;
  }

  .ops-tags-input .menu .uk-icon:hover {
    color: red;
  }

  .ops-tags-input .inputoption {
    padding: 6px 10px; margin-left:15px;
    border-radius: 6px;
    border: 1px solid #B8DEE6;
    background: #CEEBF2;
    color:#3782AA;
    cursor: pointer;
    height: 34px;
  }

  .deleteFormCritere {
    float: right;
  }

  .advform .uk-input {
    height: 34px;
    border: 1px solid #E9E9E9;
    border-radius: 6px;
    color: #222222;
    font-size: 12px;
  }

  .form-list-wrap .ti-selected-item{
    background-color: #0186B1;;
  }
</style>
